import React, { useState } from 'react';
import styled from 'styled-components';

const ActionButton = styled.button`
  width: 100%;
  min-height: 44px;
  border: 0;
  border-radius: 8px;
  background: #2d6cdf;
  color: #ffffff;
  padding: 0 14px;
  font-size: 0.95rem;
  font-weight: 900;
  cursor: pointer;

  &:hover {
    background: #235fc8;
  }
`;

const TotalSummary = styled.div`
  display: grid;
  gap: 4px;
  border: 1px solid #dce3df;
  border-radius: 8px;
  background: #f8fbff;
  color: #263747;
  padding: 10px;
  font-size: 0.9rem;
  font-weight: 800;
`;

const SummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
`;

const TaxButton = ({customerId, lines, cartNote, handleDraftOrderIdChange}) => {

  const [tax, setTax] = useState(0);
  const [totalCost, setTotalCost] = useState(0);


  const fetchTotalWithTax = async () => {

    const reformattedLines = lines.map(line => {
        const variant_id = parseInt(line.merchandise.id.split('/').pop());
        const quantity = line.quantity;
        const properties = (line.attributes || []).reduce((acc, attr) => {
          acc[attr.key] = attr.value;
          return acc;
        }, {});
      
        return { variant_id, quantity, properties };
    });




    try {
      const response = await fetch("https://api.pacificpearltraining.site/api/tax-rate", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          customerId: customerId,
          lineItems: reformattedLines,
          note: cartNote
        }),
      });

      const data = await response.json();
      console.log(data); // You can handle the response as per your requirement
     
      // Update the state variables with the new data
      setTax(data.total_tax);
      setTotalCost(data.total_price);
      handleDraftOrderIdChange(data.draft_order_id);

    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <div>
      <ActionButton type="button" onClick={fetchTotalWithTax}>Get Tax</ActionButton>
      {(tax > 0 || totalCost > 0) && (
        <TotalSummary>
          {tax > 0 && (
            <SummaryRow>
              <span>Tax</span>
              <span>{tax}</span>
            </SummaryRow>
          )}
          {totalCost > 0 && (
            <SummaryRow>
              <span>Total</span>
              <span>{totalCost}</span>
            </SummaryRow>
          )}
        </TotalSummary>
      )}
    </div>
  );
};

export default TaxButton;
